import React, { forwardRef } from 'react';

import { IconProps, Theme, Size} from './Icon.types';
import { Styles, StyledIcon } from './Icon.theme';

// const ThemedIcon = styled(Icon)(IconThemer.classes);

const IconComponent: React.FC<IconProps> = forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
  const { id, children, className, style, size, theme } = props;
  const themeClassName = Styles[theme ?? Theme.dark];
  const sizeClassName = Styles[size ?? Size.medium];

  return (
    <StyledIcon
      id={id}
      ref={ref}
      IconClassName={className}
      IconTheme={themeClassName}
      IconSize={sizeClassName}
      style={style}
    >
      {children}
    </StyledIcon>
  );
});

IconComponent.defaultProps = {
  id: undefined,
  className: undefined,
  style: undefined,
  theme: Theme.inherit,
  size: Size.medium,
};

export const IconTheme = Theme;
export const IconSize = Size;
export default IconComponent;
